

const TIPTAP_TIP = '[vuetify-pro-tiptap]'

export default class Logger {
  static warn(msg) {
    console.warn(`${TIPTAP_TIP}: ${msg}`)
  }

  static error(msg) {
    console.error(`${TIPTAP_TIP}: ${msg}`)
  }
}